/* Karma Wall: accessible lightbox (native <dialog>) and strip arrows. Vanilla, no dependencies.
   All content is server-rendered; without JS the photo links open the image file. */
(function () {
  if (window.__karmaWall) return;
  window.__karmaWall = true;

  var dlg, imgEl, quoteEl, nameEl, prevBtn, nextBtn, closeBtn;
  var list = [], idx = 0, opener = null;
  var ICON_PREV = '<svg aria-hidden="true" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.5 4.5L7 10l5.5 5.5"/></svg>';
  var ICON_NEXT = '<svg aria-hidden="true" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 4.5L13 10l-5.5 5.5"/></svg>';
  var ICON_CLOSE = '<svg aria-hidden="true" viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>';

  function make(tag, cls, html) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (html) el.innerHTML = html;
    return el;
  }

  function build() {
    if (dlg) return;
    dlg = make('dialog', 'kw kw-dialog');
    dlg.setAttribute('aria-label', 'Takkekort');
    var body = make('div', 'kw-dialog__body');
    var media = make('div', 'kw-dialog__media');
    imgEl = make('img');
    media.appendChild(imgEl);
    var text = make('div', 'kw-dialog__text');
    quoteEl = make('blockquote', 'kw-dialog__quote');
    nameEl = make('p', 'kw-dialog__name');
    text.appendChild(quoteEl);
    text.appendChild(nameEl);
    body.appendChild(media);
    body.appendChild(text);
    closeBtn = make('button', 'kw-dialog__btn kw-dialog__close', ICON_CLOSE);
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Luk');
    prevBtn = make('button', 'kw-dialog__btn kw-dialog__prev', ICON_PREV);
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Forrige takkekort');
    nextBtn = make('button', 'kw-dialog__btn kw-dialog__next', ICON_NEXT);
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Næste takkekort');
    dlg.appendChild(body);
    dlg.appendChild(closeBtn);
    media.appendChild(prevBtn);
    media.appendChild(nextBtn);
    document.body.appendChild(dlg);

    closeBtn.addEventListener('click', function () { dlg.close(); });
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('kw-lock');
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    });
  }

  function fill() {
    var a = list[idx];
    var card = a.closest('.kw-card');
    var thumb = a.querySelector('img');
    var q = card.querySelector('.kw-quote p');
    var nm = card.querySelector('.kw-name');
    var cx = card.querySelector('.kw-ctx');
    imgEl.src = a.getAttribute('href');
    imgEl.alt = thumb ? thumb.alt : '';
    imgEl.width = thumb ? thumb.width : 0;
    imgEl.height = thumb ? thumb.height : 0;
    quoteEl.textContent = q ? q.textContent : '';
    nameEl.textContent = '';
    nameEl.appendChild(document.createTextNode(nm ? nm.textContent : ''));
    if (cx && cx.textContent) {
      var span = make('span', 'kw-dialog__ctx');
      span.textContent = ' · ' + cx.textContent;
      nameEl.appendChild(span);
    }
    prevBtn.hidden = nextBtn.hidden = list.length < 2;
  }

  function step(d) {
    if (list.length < 2) return;
    idx = (idx + d + list.length) % list.length;
    fill();
  }

  function open(a) {
    var group = a.closest('[data-kw-group]');
    list = group ? Array.prototype.slice.call(group.querySelectorAll('[data-kw-open]')).filter(function (x) { return x.offsetParent !== null; }) : [a];
    idx = Math.max(0, list.indexOf(a));
    opener = a;
    build();
    fill();
    document.documentElement.classList.add('kw-lock');
    dlg.showModal();
    closeBtn.focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-kw-open]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    open(a);
  });


  /* ---- text notes: expand long quotes ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kw-expand]');
    if (!b) return;
    var card = b.closest('.kw-card');
    var open = card.classList.toggle('kw-card--expanded');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = open ? 'Vis mindre' : 'Læs hele';
  });

  /* ---- collage: "Vis flere" reveals the cards that are already in the HTML ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kw-more]');
    if (!b) return;
    var list = document.getElementById(b.getAttribute('aria-controls'));
    if (!list) return;
    var first = list.querySelector('.kw-card--extra');
    list.removeAttribute('data-kw-collapsed');
    b.setAttribute('aria-expanded', 'true');
    var wrap = b.closest('.kw-more-wrap');
    if (wrap) wrap.hidden = true;
    var target = first && first.querySelector('a, button');
    if (target) target.focus({ preventScroll: true });
  });

  /* ---- strip arrows ---- */
  var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function stripStep(track) {
    var card = track.querySelector('.kw-card');
    if (!card) return track.clientWidth;
    return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 16);
  }

  function updateStrip(root) {
    var track = root.querySelector('[data-kw-track]');
    var prev = root.querySelector('[data-kw-prev]');
    var next = root.querySelector('[data-kw-next]');
    if (!track || !prev || !next) return;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }

  function initStrips() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kw-strip]'), function (root) {
      if (root.__kwReady) { updateStrip(root); return; }
      root.__kwReady = true;
      var track = root.querySelector('[data-kw-track]');
      if (!track) return;
      track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { updateStrip(root); }); }, { passive: true });
      updateStrip(root);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kw-prev], [data-kw-next]');
    if (!b) return;
    var root = b.closest('[data-kw-strip]');
    var track = root && root.querySelector('[data-kw-track]');
    if (!track) return;
    var dir = b.hasAttribute('data-kw-prev') ? -1 : 1;
    track.scrollBy({ left: dir * stripStep(track), behavior: smooth ? 'smooth' : 'auto' });
  });

  window.addEventListener('resize', initStrips);
  document.addEventListener('shopify:section:load', initStrips);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStrips);
  else initStrips();
  window.addEventListener('load', initStrips);
})();
